
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSleetShowersPolartwilightColour as ObiLightSleetShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-sleet-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiLightSleetShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-light-sleet-showers-polartwilight-colour',
   elementClass: ObiLightSleetShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 